<template>
    <div class="www pb-2 select-none">
        <div class="www py-2">
            <label
                for="changeLog"
                class="block text-sm font-medium text-gray-700 select-none"
            >
                {{ t('templateVersionChangeLog') }}
            </label>
            <input
                id="changeLog"
                v-model="templateVersionEdit.changeLog"
                type="text"
                name="changeLog"
                autocomplete="off"
                :class="[
                    ark(templateVersionEdit, 'changeLog').length === 0
                        ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
                        : 'border-gray-300 focus:border-blue-500 focus:ring-blue-500',
                    'mt-1 block w-full rounded-md border px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 focus:outline-hidden sm:text-sm',
                ]"
            />
        </div>
        <div class="www py-2">
            <label
                for="subject"
                class="block text-sm font-medium text-gray-700 select-none"
            >
                {{ t('templateVersionSubject') }}
            </label>
            <input
                id="subject"
                v-model="templateVersionEdit.subject"
                type="text"
                name="subject"
                autocomplete="off"
                :class="[
                    ark(templateVersionEdit, 'subject').length === 0
                        ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
                        : 'border-gray-300 focus:border-blue-500 focus:ring-blue-500',
                    'mt-1 block w-full rounded-md border px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 focus:outline-hidden sm:text-sm',
                ]"
            />
        </div>

        <div class="www py-2">
            <label
                for="template-lang-code"
                class="block text-sm font-medium text-gray-700"
            >
                {{ t('templateLanguage') }}
            </label>
            <select
                id="template-lang-code"
                v-model="templateVersionEdit.langCode"
                name="template-lang-code"
                class="focus:border-blue-500cd mod mt-1 block w-full rounded-md border border-gray-300 bg-white px-3 py-2 shadow-sm focus:ring-blue-500 focus:outline-hidden sm:text-sm"
            >
                <option
                    v-for="lng in supportedTemplateLangs"
                    :key="lng.code"
                    :value="lng.code.toLocaleUpperCase()"
                >
                    {{ lng.name }}
                </option>
            </select>
        </div>

        <div class="www py-2">
            <label
                for="version"
                class="block text-sm font-medium text-gray-700 select-none"
            >
                {{ t('templateVersion') }}
            </label>
            <input
                id="version"
                v-model="templateVersionEdit.version"
                type="text"
                name="version"
                autocomplete="off"
                :readonly="templateVersionId !== '0'"
                :class="[
                    templateValidation.version === 0 || !templateValidation.version
                        ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
                        : 'border-gray-300 focus:border-blue-500 focus:ring-blue-500',
                    'mt-1 block w-full rounded-md border px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 focus:outline-hidden sm:text-sm',
                ]"
            />
        </div>
    </div>
</template>

<script setup>
    import { ark } from '../composables/utils';
    import { supportedTemplateLangs } from '../composables/i18n';

    defineExpose({
        name: 'BasicsWidget',
    });

    const props = defineProps({
        templateVersionEdit: {
            type: Object,
            required: true,
        },
        templateValidation: {
            type: Object,
            required: true,
        },
        templateVersionId: {
            type: String,
            required: true,
        },
    });

    const templateVersionEdit = props.templateVersionEdit;
    const templateVersionId = props.templateVersionId;
</script>
